import { useMutation } from 'react-query'
import request from '../request'

export const useUnlockUserAccount = () => {
  return useMutation(({ user_id }: { user_id: string }) =>
    request({
      url: `/admin/users/${user_id}/unlock_account`,
      method: 'POST',
    }),
  )
}
